/**
* ---------------------------------------------
* Age Gate
* Confirm user age before accessing site
* ---------------------------------------------
*/

import trapFocus from './trapfocus.js'

/**
* Custom HTML Element for age-gate
*/
const ageGate = class extends HTMLElement {
  constructor () {
    super()

    this.cookieName = 'botany_age_confirmed'
    this.initAgeGate()
  }

  /**
   * Initializes the age gate modal
   * @returns true if successful
   */
  initAgeGate () {
    try {
      this.cookieExists = this.checkCookie()

      if (this.cookieExists) { return true }

      this.cookieExpiration = parseInt(this.dataset.ageGateCookieExpiration, 10)
      this.yesBtn = this.querySelector('[data-age-gate-yes]')
      this.noBtn = this.querySelector('[data-age-gate-no]')

      this.openModal()
      this.ageGateEvents()
    } catch (err) {
      console.error(err)
    }

    return true
  }

  /**
   * Checks for age gate cookie
   * @returns true if cookie exists
   */
  checkCookie () {
    const match = document.cookie.match(new RegExp('(^| )' + this.cookieName + '=([^;]+)'))

    if (match) {
      return true
    } else {
      return false
    }
  }

  /**
   * Set age gate cookie with expiry
   */
  setCookie () {
    const expires = (new Date(Date.now() + 86400 * (this.cookieExpiration * 1000))).toUTCString()
    document.cookie = `${this.cookieName}=true;expires=${expires};path=/;`
  }

  /**
   * Age gate event handling
   */
  ageGateEvents () {
    this.yesBtn.addEventListener('click', () => {
      this.setCookie()
      this.closeModal()
    })

    this.noBtn.addEventListener('click', () => {
      window.history.back()
    })
  }

  /**
   * Open age gate modal
   */
  openModal () {
    this.classList.add('active')
    document.body.classList.add('scroll-lock')
    trapFocus.open(this)
  }

  /**
   * Close age gate modal
   */
  closeModal () {
    this.classList.remove('active')
    document.body.classList.remove('scroll-lock')
    trapFocus.close()
  }
}

if (typeof window.customElements.get('age-gate') === 'undefined') {
  window.customElements.define('age-gate', ageGate)
}
